import { DepositSchema } from '@/views/account/Deposit/styles/Deposit.styles';

export const depositStyles: DepositSchema = {
  inputCardHolderNameProps: {
    sx: {
      '&&&': {
        h: 10,
        fontSize: 'xs',
        px: 3,
        fontWeight: 'medium',
        border: 'none',
        boxShadow:
          '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
        bg: 'blackAlpha.500',
        color: 'white',
        fontFamily: 'accent',
        '&&&': {
          ':hover': {
            bg: 'blackAlpha.400',
            color: 'white',
          },
          ':active, :focus': {
            bg: 'blackAlpha.600',
            color: 'white',
          },
        },
      },
    },
  },
};
